// Date formatting helpers built on date-fns (tree-shakeable — import only what we use).
import { format, parseISO, formatDistanceToNow, isValid, differenceInCalendarDays } from 'date-fns';

const toDate = (value) => {
  if (!value) return null;
  const d = typeof value === 'string' ? parseISO(value) : value;
  return isValid(d) ? d : null;
};

export const DATE_FORMAT = 'dd/MM/yyyy';

export const formatDate = (value, pattern = DATE_FORMAT) => {
  const d = toDate(value);
  return d ? format(d, pattern) : '';
};

export const formatDateTime = (value) => formatDate(value, `${DATE_FORMAT}, HH:mm`);

// What an <input type="date"> requires — never DATE_FORMAT, which it silently rejects.
const DATE_INPUT_FORMAT = 'yyyy-MM-dd';

export const formatDateInput = (value) => formatDate(value, DATE_INPUT_FORMAT);

// Table cells show a dash rather than an empty gap when there is no date.
export const formatDateOrDash = (value) => formatDate(value) || '-';

export const fromNow = (value) => {
  const d = toDate(value);
  return d ? formatDistanceToNow(d, { addSuffix: true }) : '';
};

/** Whole days from today to `value`; negative once the date has passed, null when unset. */
export const daysUntil = (value) => {
  const d = toDate(value);
  return d ? differenceInCalendarDays(d, new Date()) : null;
};
